(ns frontend.ui.component.select-input-group.style)

(defn select-input-group-style
  []
  {:display       :block
   :margin-bottom "16px"})
